import { getMcpBaseUrl } from '@/config/mcpBaseUrl';

export type McpOAuthRedirectParams = Record<string, string>;

/**
 * Create a server-side OAuth session handoff and build the MCP /authorize URL.
 * Tokens are sent via POST body only; the redirect URL carries handoff_id + OAuth params.
 */
export async function buildMcpAuthorizeUrlWithHandoff(
  accessToken: string,
  refreshToken: string,
  oauthParams: McpOAuthRedirectParams
): Promise<string> {
  const mcpBaseUrl = getMcpBaseUrl();
  const response = await fetch(`${mcpBaseUrl}/oauth/session-handoff`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      access_token: accessToken,
      refresh_token: refreshToken,
    }),
  });

  if (!response.ok) {
    const detail = await response.text().catch(() => '');
    throw new Error(
      detail || `MCP session handoff failed (${response.status})`
    );
  }

  const payload = (await response.json()) as { handoff_id?: string };
  if (!payload.handoff_id) {
    throw new Error('MCP session handoff response missing handoff_id');
  }

  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(oauthParams)) {
    if (value) {
      params.set(key, value);
    }
  }
  params.set('handoff_id', payload.handoff_id);

  return `${mcpBaseUrl}/authorize?${params.toString()}`;
}
